<template>
	<nav class="navbar is-fixed-bottom has-shadow is-hidden-desktop" role="navigation" aria-label="main navigation" v-if="hasActiveLeague">
		<div class="navbar-flex">
			<MobileNavItem
				:route="{ name: 'league-home', params: { leagueKey: activeLeague.key } }"
				:icon="['far', 'home']"
				text="Dashboard"
			/>
			<MobileNavItem
				:route="{ name: 'league-playoffs', params: { leagueKey: activeLeague.key } }"
				:icon="['far', 'trophy']"
				text="Playoffs"
			/>
			<MobileNavItem
				:route="{ name: 'league-draft-dashboard', params: { leagueKey: activeLeague.key } }"
				:icon="['far', 'beer']"
				text="Draft"
			/>
			<MobileNavItem
				:route="{ name: 'league-players', params: { leagueKey: activeLeague.key } }"
				:icon="['far', 'user']"
				text="Players"
			/>
			<MobileNavItem
				:route="{ name: 'league-faqs', params: { leagueKey: activeLeague.key } }"
				:icon="['far', 'question-circle']"
				text="FAQs"
			/>
		</div>
	</nav>
</template>

<script>
import MobileNavItem from "./MobileNavItem"

export default {
	components: {
		MobileNavItem,
	},
	computed: {
		hasActiveLeague() {
			return !!this.$store.getters.activeLeague
		},
		activeLeague() {
			return this.$store.getters.activeLeague
		},
	},
}
</script>

<style scoped>
.navbar {
	align-items: center;
	display: flex;
}

.navbar-flex {
	display: flex;
	flex: 1;
	justify-content: space-between;
	padding: 0;
}

.navbar-flex > * {
	flex: 1;
	text-align: center;
}

.navbar-item {
	align-items: center;
	display: flex;
	flex-flow: column;
}

.navbar.is-fixed-bottom.has-shadow {
	border-top: 1px solid whitesmoke;
	box-shadow: none;
}
</style>
